import { Tune } from "@mui/icons-material";
import { Button } from "@mui/material";

import HNSColors from "../../../ui library/HNSColors";

export const FiltersButton = ({ children, sx, startIcon, ...props }) => {
  return (
    <Button
      variant="outlined"
      startIcon={startIcon || <Tune />}
      className="capitalize"
      sx={{
        gap: "10px",
        borderRadius: "999px",
        color: HNSColors.secondary[400],
        border: `1px solid ${HNSColors.secondary[400]}`,
        p: 1,
        px: 3,
        "&:hover": {
          backgroundColor: HNSColors.secondary[900],
          borderColor: HNSColors.secondary[900],
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
